module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-7000-Classes-Active-16a72a0111e90726b661ed0d8d64e053.png";